/* Search modal — single, linear flow. */
(function () {
  'use strict';

  /* DOM lookup (always live; no caching, no rot) */
  function getModal() { return document.getElementById('search-modal'); }
  function getDialog() { var m = getModal(); return m ? m.querySelector('dialog') : null; }
  function getInput() { return document.getElementById('cmdk-input'); }
  function getWrapper() {
    var m = getModal();
    return m ? m.querySelector('.predictive-search-form__content-wrapper') : null;
  }

  /* Pill layout detection */
  function isPillLayout() {
    var header = document.getElementById('header-component');
    if (!header) return false;
    if (!header.classList.contains('header-new')) return false;
    return window.matchMedia('(min-width: 750px)').matches;
  }

  /* Searchanise: relocate results into our scroll container */
  function relocateSearchaniseResults() {
    var wrapper = getWrapper();
    if (!wrapper) return;
    var nodes = document.querySelectorAll('.snize-ac-results, .snize-ac-results-mobile');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.parentElement !== wrapper) {
        wrapper.appendChild(n);
        n.setAttribute('data-snize-relocated', 'true');
      }
    }
  }

  function watchForSearchaniseResults() {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          var matches = n.matches && (n.matches('.snize-ac-results') || n.matches('.snize-ac-results-mobile'));
          var contains = n.querySelector && n.querySelector('.snize-ac-results, .snize-ac-results-mobile');
          if (matches || contains) {
            relocateSearchaniseResults();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* Searchanise: force desktop autocomplete chrome */
  function forceSearchaniseDesktopMode() {
    var sa = window.Searchanise;
    var input = getInput();
    if (!sa || typeof sa.$ !== 'function' || !input) return false;
    var ac = sa.$(input).data('autocompleter');
    if (!ac || !ac.select) return false;
    ac.select.isMobileMode = function () { return false; };
    return true;
  }

  function bootstrapSearchaniseDesktopMode() {
    if (forceSearchaniseDesktopMode()) return;
    var tries = 0;
    var iv = setInterval(function () {
      if (forceSearchaniseDesktopMode() || ++tries > 50) clearInterval(iv);
    }, 100);
    document.addEventListener('AutocompleteUpdate', forceSearchaniseDesktopMode);
  }

  /* Pin the pill header to the viewport while open */
  function pinHeader() {
    var header = document.getElementById('header-component');
    if (!header || !isPillLayout()) return;
    var root = document.documentElement;
    if (root.style.getPropertyValue('--search-header-pin-top')) return;
    root.style.setProperty('--search-header-pin-top', header.getBoundingClientRect().top + 'px');
  }

  /* Open / close lifecycle (single observer) */
  var lastOpenState = false;

  function onOpen() {
    var input = getInput();
    var modal = getModal();
    if (!input || !modal) return;

    pinHeader();
    document.body.classList.toggle('search-modal-pill-active', isPillLayout());

    input.value = '';
    // One input event tells Searchanise the field is empty so it tears
    // any cached result list down — the same event the browser fires
    // when the user types.
    input.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
    modal.classList.add('search-modal--empty');

    relocateSearchaniseResults();

    // Synchronous focus inside the user gesture. iOS only opens the
    // soft keyboard for a programmatic focus that happens inside the
    // gesture context — RAF or setTimeout puts it a frame too late
    // and the keyboard never appears.
    try { input.focus({ preventScroll: true }); }
    catch (e) { input.focus(); }
  }

  function onClose() {
    var input = getInput();
    var modal = getModal();
    document.body.classList.remove('search-modal-pill-active');
    if (input) {
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
    }
    if (modal) {
      modal.classList.add('search-modal--empty');
      // Reset the sticky "has-typed" expansion so the next open starts
      // collapsed at its natural input-row height.
      modal.classList.remove('search-modal--has-typed');
    }
    // NOTE: we intentionally do NOT wipe Searchanise's result HTML here.
    // Searchanise's autocompleter holds internal references to the DOM
    // inside #snize-instant-search-results; destroying it with
    // innerHTML='' leaves those references dangling, so on the NEXT open
    // Searchanise updates detached nodes and renders nothing (the
    // "reopen → no results" bug). The empty `input` event dispatched
    // above already makes Searchanise run its own hide() to tear the
    // result list down, and `.search-modal--empty` hides it via CSS —
    // so the panel starts blank without us touching Searchanise's DOM.
    document.documentElement.style.removeProperty('--search-vv-height');
    document.documentElement.style.removeProperty('--search-vv-top');
    document.documentElement.style.removeProperty('--search-header-pin-top');
  }

  function ensureLifecycle(dialog) {
    var open = !!dialog.open;
    if (open === lastOpenState) return;
    lastOpenState = open;
    if (open) onOpen(); else onClose();
  }

  /* Show / close patches */
  var savedScrollY = 0;
  var closingInProgress = false;
  var CLOSE_ANIMATION_MS = 220;

  function patchDialog(dialog, modal) {
    if (dialog.dataset.searchModalShowPatched === 'true') return;
    dialog.dataset.searchModalShowPatched = 'true';

    var nativeShowModal = HTMLDialogElement.prototype.showModal.bind(dialog);

    dialog.showModal = function () {
      if (dialog.open) return;
      savedScrollY = window.scrollY;
      pinHeader();
      if (isPillLayout()) {
        dialog.show();
      } else {
        nativeShowModal();
      }
      ensureLifecycle(dialog);
    };

    modal.closeDialog = function () {
      if (!dialog.open) return;
      if (closingInProgress) return;
      closingInProgress = true;

      dialog.classList.add('dialog-closing');

      setTimeout(function () {
        document.body.style.width = '';
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo({ top: savedScrollY, behavior: 'instant' });

        dialog.close();
        dialog.classList.remove('dialog-closing');
        modal.dispatchEvent(new CustomEvent('dialog:close', { bubbles: true }));

        closingInProgress = false;
      }, CLOSE_ANIMATION_MS);
    };

    // toggleDialog already routes to closeDialog/showDialog, so by
    // overriding closeDialog we cover the X button (declarative
    // on:click="dialog-component/closeDialog"), CMD+K toggle, and any
    // other consumer.
  }

  function bindLifecycleObserver(dialog) {
    new MutationObserver(function () {
      ensureLifecycle(dialog);
    }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
  }

  /* Outside-click close (one owner, reliable on iOS) */
  function bindOutsideClickClose(dialog, modal) {
    document.addEventListener('click', function (event) {
      if (!dialog.open) return;
      var target = event.target;
      if (!(target instanceof Element)) return;
      if (dialog.contains(target)) return;
      // Don't react to the button that just opened the modal.
      if (target.closest('.search-modal__button, [aria-controls="search-modal"]')) return;
      modal.closeDialog();
    }, true);
  }

  /* Empty-state class on the modal */
  function bindEmptyStateTracking() {
    var input = getInput();
    var modal = getModal();
    if (!input || !modal) return;
    function update() {
      var isEmpty = !input.value.length;
      modal.classList.toggle('search-modal--empty', isEmpty);
      if (!isEmpty) modal.classList.add('search-modal--has-typed');
    }
    input.addEventListener('input', update);
    update();
  }
  /* Searchanise: mirror the field into its hidden mobile panel input.
     On mobile Searchanise builds its own panel input
     (#snize-mobile-search-input) and its hide() ends with `z.val(y.val())`,
     copying that input back into ours. We hide it and keep a single visible
     field, so it holds the last query forever and the restore puts deleted
     text back the moment the field is emptied. Mirroring makes that write an
     identity write. It also makes Enter submit what the shopper actually
     typed — submitSearchForm submits the panel input on mobile. */
  function bindShadowInputSync() {
    var input = getInput();
    if (!input || input.dataset.shadowSyncBound === 'true') return;
    input.dataset.shadowSyncBound = 'true';
    input.addEventListener('input', function () {
      // Looked up per event: Searchanise creates it lazily, on first render.
      var shadow = document.getElementById('snize-mobile-search-input');
      if (shadow && shadow.value !== input.value) shadow.value = input.value;
    });
  }

  /* Suppress Searchanise's self-blur */
  function guardInputBlur(dialog) {
    var input = getInput();
    if (!input || input.dataset.blurGuarded === 'true') return;
    input.dataset.blurGuarded = 'true';

    var nativeBlur = input.blur.bind(input);
    // Expose the un-guarded blur so onClose() can still drop focus.
    input.__nativeBlur = nativeBlur;

    input.blur = function () {
      if (dialog.open && !closingInProgress) return;
      return nativeBlur();
    };
  }

  /* Re-focus the input on tap */
  function bindRefocusOnTap() {
    var input = getInput();
    if (!input || input.dataset.refocusBound === 'true') return;
    input.dataset.refocusBound = 'true';
    function refocus() {
      // If the keyboard is already up (visual viewport noticeably shorter than
      // the layout viewport) and we're focused, do nothing — avoids a flicker
      // on every tap while actively typing.
      var vv = window.visualViewport;
      var keyboardUp = vv && (window.innerHeight - vv.height) > 120;
      if (keyboardUp && document.activeElement === input) return;
      try { if (input.__nativeBlur) input.__nativeBlur(); else input.blur(); }
      catch (e) { /* ignore */ }
      try { input.focus({ preventScroll: true }); }
      catch (e) { input.focus(); }
    }
    // touchend fires first and is the most reliable iOS keyboard trigger;
    // click is the desktop/fallback path.
    input.addEventListener('touchend', refocus, { passive: true });
    input.addEventListener('click', refocus);
  }

  /* Visual viewport (iOS soft keyboard) */
  function bindVisualViewport(dialog) {
    if (!window.visualViewport) return;
    var vv = window.visualViewport;
    var rafId = 0;
    function update() {
      if (!dialog.open) {
        document.documentElement.style.removeProperty('--search-vv-height');
        document.documentElement.style.removeProperty('--search-vv-top');
        return;
      }
      document.documentElement.style.setProperty('--search-vv-height', vv.height + 'px');
      document.documentElement.style.setProperty('--search-vv-top', vv.offsetTop + 'px');
    }
    function schedule() {
      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        rafId = 0;
        update();
      });
    }
    vv.addEventListener('resize', schedule);
    vv.addEventListener('scroll', schedule);
    window.addEventListener('orientationchange', schedule);
    // Run once after the dialog opens (catches the initial layout pass
    // before the user has focused the input).
    new MutationObserver(schedule).observe(dialog, {
      attributes: true,
      attributeFilter: ['open']
    });
  }

  /* Init (idempotent) */
  function init() {
    var modal = getModal();
    var dialog = getDialog();
    if (!modal || !dialog) return false;
    if (dialog.dataset.searchModalBound === 'true') return true;
    dialog.dataset.searchModalBound = 'true';

    lastOpenState = !!dialog.open;

    patchDialog(dialog, modal);
    bindLifecycleObserver(dialog);
    bindOutsideClickClose(dialog, modal);
    bindEmptyStateTracking();
    bindShadowInputSync();
    guardInputBlur(dialog);
    bindRefocusOnTap();
    bindVisualViewport(dialog);
    relocateSearchaniseResults();
    watchForSearchaniseResults();
    bootstrapSearchaniseDesktopMode();

    return true;
  }

  if (!init()) {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  }
})();
